



















import Vue from 'vue'

import Actions from '@/components/actions.vue';;

export default Vue.extend({
    components: {
        action: Actions,
    },
    props: {
        tagline: String,
        title: String,
        buttons: Array,
        bottomButtons: Array,
        details: String,
    },
    methods: {
        goApp() {
        this.$router.push('/app')
        }
    },
})
